(function ($) {
	class W4D_MyAccount {
		constructor() {
			this.initSelectors();
			this.bindEvents();
			this.initShippingFields();
		}

		initSelectors() {
			// Password reset
			this.passwordResetForm = $('#password-reset-form');

			// Account info
			this.accountInfoForm = $('#form-account-info');
			this.accountInfoSave = this.accountInfoForm.find('button[type="submit"]');

			this.shipToDifferentCheckbox = $('#ship-to-different-address-checkbox');
			this.shippingFields = $('.shipping-fields-container');

			// Repeat Order Action
			this.repeatOrderElement = $('.repeat-order-action');

			// Cancel order

			this.cancelOrderButton = $('.cancel-order-button');
			this.orderTable = $('.table-order');

			// IOS
			this.infoBox = $('.info-box');
			this.infoBoxClose = this.infoBox.find('.js-close');
		}

		bindEvents() {
			// Password reset events
			this.passwordValidator = this.passwordResetForm.validate({
				submitHandler: (form) => {
					this.handlePasswordChangeSubmit(form);
				},
			});

			// Account info events
			this.shipToDifferentCheckbox.on('change', () => this.toggleShippingFields());

			this.accountInfoForm.validate({
				submitHandler: (form) => {
					this.handleAccountInfoSubmit(form);
				},
			});

			// Dugovanje
			this.infoBoxClose.on('click', (e) => this.closeIos(e));

			// Cancel order

			this.cancelOrderButton.on('click', (e) => this.handleCancelOrder(e));
		}

		closeIos() {
			this.infoBox.addClass('info-box--hide');
		}

		// ---------------------------------------->> ACCOUNT INFO METHODS <<----------------------------------------||
		initShippingFields() {
			this.toggleShippingFields();
		}

		toggleShippingFields() {
			if (this.shipToDifferentCheckbox.is(':checked')) {
				this.shippingFields.slideDown(300);
			} else {
				this.shippingFields.slideUp(300);
			}
		}

		handleAccountInfoSubmit(form) {
			const fd = new FormData(form);

			fd.append('ship_to_different_address', this.shipToDifferentCheckbox.is(':checked'));
			fd.append('action', 'update_customer_data');
			fd.append('nonce', w4d_frontend_ajax.nonce);

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: fd,
				processData: false,
				contentType: false,
				beforeSend: () => {
					this.accountInfoSave.prop('disabled', true).text('Spremanje...');
				},
				success: (response) => {
					if (response.success) {
						W4D_Toast.showToast('success', 'Podaci su uspješno spremljeni');
					} else {
						W4D_Toast.showToast('error', 'Došlo je do greške prilikom spremanja');
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Došlo je do greške prilikom spremanja');
				},
				complete: () => {
					this.accountInfoSave.prop('disabled', false).text('Spremi promjene');
				},
			});
		}

		handlePasswordChangeSubmit(form) {
			const ajaxData = {
				action: 'w4d_change_password',
				old_password: $(form).find('#old-password').val(),
				new_password: $(form).find('#new-password').val(),
				nonce: w4d_frontend_ajax.nonce,
			};

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				success: (response) => {
					if (response.success) {
						W4D_Toast.showToast('success', 'Uspješno promijenjena lozinka.');
						this.passwordValidator.resetForm();
						this.passwordResetForm[0].reset();
					} else {
						W4D_Toast.showToast('error', response.data.message);
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Došlo je do greške. Pokušajte ponovno.');
				},
			});
		}

		handleCancelOrder(e) {
			e.preventDefault();

			if (!confirm('Jeste li sigurni da želite otkazati narudžbu?')) return;

			let orderNumber = $(e.currentTarget).data('order-number');

			const ajaxData = {
				action: 'w4d_cancel_order',
				order_number: orderNumber,
				order_key: $(e.currentTarget).attr('data-order-key') || '',
				nonce: w4d_frontend_ajax.nonce,
			};

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					this.cancelOrderButton.prop('disabled', true);
					this.orderTable.addClass('is-loading');
				},
				success: (response) => {
					if (response.success) {
						W4D_Toast.showToast('success', 'Narudžba #' + orderNumber + ' uspješno otkazana.');
					} else {
						W4D_Toast.showToast('error', response.data.message);
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Došlo je do greške. Pokušajte ponovno.');
				},
				complete: (response) => {
					setTimeout(() => {
						location.reload();
						this.cancelOrderButton.prop('disabled', false);
					}, 1000);
				},
			});
		}
	}

	$(document).ready(function () {
		new W4D_MyAccount();
	});
})(jQuery);
